var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ranking-overtime-chart"},[(_vm.data.length > 0 || _vm.data.overtime.length > 0)?_c('canvas',{staticStyle:{"width":"1050px"},attrs:{"id":_vm.makeSpecialId()}}):_c('app-heading',{staticStyle:{"color":"#000"},attrs:{"level":"h4"}},[_vm._v("Falha ao obter resposta do servidor")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }